import {SessionService} from "../../../services/session.service";

export class CustomComponent{

  private _componentId: string;

  constructor(name:string){
    this._componentId =  name + '.' + Math.floor(Math.random() * 10000);
  }

  public get componentId(){
    return this._componentId;
  }

  public onDragOver(event){
//    console.log('OnDragOver ',event);
    // event.dataTransfer.effectAllowed = 'move';
    // if (event.altKey===true){
    //   event.dataTransfer.effectAllowed="copy";
    // }

  }

  public onDragStart(session: SessionService,event){
    console.log('OnDragStart ',event);
    if (!session.copyOnlyScheduleWithDnd()){
      event.dataTransfer.effectAllowed = 'move';
      if (event.altKey===true){
        event.dataTransfer.effectAllowed="copy";
      }
      // event.preventDefault();
      // event.bodyElement.style.cursor = 'move';
      event.dataTransfer.dropEffect="move";
      if (event.altKey===true){
        event.dataTransfer.dropEffect="copy";
      }
    }
  }

}
